/** Shared with the relay's own limits. Kept in one place so client and server cannot disagree. */
export const MAX_FRAGMENT_BYTES = 64 * 1024;
export const MAX_FRAGMENT_MS = 8_000;
export const MIN_FRAGMENT_MS = 300;
